import {Injectable} from "@angular/core";
import {CreateDeliveryPointUseCase} from "@app/core/delivery-point/application/create-delivery-point.use-case";
import {CreateDeliveryPointData} from "@app/core/delivery-point/application/dtos/create-delivery-point-data";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {createStatusStore} from "@app/presentation/rxjs-utils/create-status-store";
import {switchMap, take} from "rxjs/operators";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";
import {Observable} from "rxjs";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {onError} from "@app/presentation/rxjs-utils/operators/on-error";
import {RecaptchaAction, RecaptchaService} from "@app/presentation/services/recaptcha/recaptcha.service";

@Injectable({
    providedIn: 'root'
})
export class CreateDeliveryPointViewModel {

    public notifier = new PopupNotifier();

    private createDeliveryPointStatus = createStatusStore();

    readonly isCreateDeliveryPointLoading$ = this.createDeliveryPointStatus.isLoading$;

    constructor(
        private createDeliveryPointUseCase:CreateDeliveryPointUseCase,
        private recaptchaService: RecaptchaService,
    ) {}

    createDeliveryPoint(createDeliveryPointData:Omit<CreateDeliveryPointData, 'recaptchaToken'>): Observable<DeliveryPoint> {
        return this.recaptchaService.getToken(RecaptchaAction.NEW_DELIVERY_POINT).pipe(
            switchMap(recaptchaToken => this.createDeliveryPointUseCase
                .execute({
                    ...createDeliveryPointData,
                    recaptchaToken,
                })
                .pipe(
                    take(1),
                    onError(error => this.notifier.notifyError(error)),
                    onIsLoadingChanges(this.createDeliveryPointStatus.setIsLoading),
                )),
        );
    }
}
